module.exports = __webpack_public_path__ + "img/blog-13-2.c4e9c194.webp";